export default "__VITE_ASSET__BYE4qXC1__"